<template>
  <div class="viewOne">
    <h1>Hola! Esta es la vista 1</h1>
  </div>
</template>

<script>
export default {
  name: 'ViewOne',
};
</script>

<style scoped>
.viewOne {
  color: #676767;
  padding: 10px 0 0 50px;
}
</style>
